<!--
  The repository a pull request is in: its owner's avatar (square, as an
  organization's or account's), then `owner/name` with the name the
  heavier. Too long for its place, the owner is cut before the name is. The one mark for "where" on the dashboard: a stack's title bar
  and a single row both lead with it.
-->
<script lang="ts">
  import Avatar from './Avatar.svelte';

  interface Props {
    /** `owner/name`. */
    repo: string;
    /** The owner's avatar; its initial stands in without one. */
    avatarUrl: string | null | undefined;
  }
  let { repo, avatarUrl }: Props = $props();
  const owner = $derived(repo.split('/')[0]);
  const name = $derived(repo.slice(owner.length + 1));
</script>

<span class="repo-mark" title="{repo} on GitHub"
  ><Avatar url={avatarUrl} name={owner} shape="square" /><span class="repo-text"
    ><span class="repo-owner">{owner}</span><span class="repo-slash">/</span><b class="repo-name">{name}</b></span
  ></span
>

<style>
  .repo-mark {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    max-width: 100%;
    color: var(--fg);
    font-size: 13px;
    line-height: 20px;
  }
  /* Where the whole name does not fit, the owner is cut first and the repository's name stays whole for as
     long as it can: the name is what tells one row from the next. */
  .repo-text {
    display: flex;
    min-width: 0;
    white-space: nowrap;
  }
  .repo-owner {
    flex: 0 1000 auto;
    min-width: 2ch;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .repo-slash {
    flex: none;
  }
  .repo-name {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 600;
  }
</style>
